<template>
  <div class="filter-container flex-row">
    <div class="filter-op">
      <menu-wrapper>
        <template #menu-button="{toggleMenu}">
          <button tabindex="-1" class="btn-filter-operator" @click="toggleMenu">
            <div :class="['icon24', nativeFilterIconClass]" />
          </button>
        </template>
        <template #menu-content>
          <template v-for="(item, i) in filterOperators" :key="i">
            <menu-item
              class="filter-operator-item"
              :class="item.enumValue === operatorValue ? 'active' : ''"
              :icon="['icon24', item.icon]"
              @menu-item-click="filterOperatorItemClick(item)"
            >
              {{ item?.enumText }}
            </menu-item>
          </template>
        </template>
      </menu-wrapper>
    </div>

    <div class="filter-value flex">
      <ms-datepicker
        ref="filterInput"
        v-model="filterValue"
        :read-only="operatorValueReadonly"
        class="datepicker w-full ms-input-filter-value"
        placeholder=""
        :has-border="false"
        @keydown.enter="filterHeaderHandle({operator: operatorValue, value: filterValue})"
        @ms-change="val => filterHeaderHandle({operator: operatorValue, value: val})"
        @keydown.stop=""
      />
    </div>
  </div>
</template>
<script>
import {defineComponent} from 'vue';
import msThOptionBase from '@/components/gridViewer/columnOption/MsThOptionBase.js';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import setup from '@/components/gridViewer/columnOption/render-helper.js';
export default defineComponent({
  name: 'MsThOptionDate',
  components: {MenuItem, MenuWrapper},
  extends: msThOptionBase,
  props: {
    filterIconClass: {
      type: String,
      default: 'ic-filter-equal',
    },
  },
  setup(props, {emit}) {
    // Variable
    const {
      nativeFilterIconClass,
      filterValue,
      filterInput,
      operatorValueReadonly,
      operatorValue,
      filterHeaderHandle,
      filterOperators,
      filterOperatorItemClick,
      removeFilter,
    } = setup(props, {emit});
    return {
      nativeFilterIconClass,
      operatorValue,
      filterValue,
      filterInput,
      operatorValueReadonly,
      filterOperators,
      filterHeaderHandle,
      filterOperatorItemClick,
      removeFilter,
    };
  },
});
</script>
